export interface Role {
  id: string;
  name: string;
  description: string;
  permissions: string[];
  isSystem: boolean;
  createdAt: any;
  updatedAt: any;
  createdBy: string;
}

// Accord-local permission ids. Per the solution isolation rule these are NOT
// registered in admin-console's permission catalog — role docs are free-form
// permission-string arrays, and accord is the only consumer of `accord.*`.
export const ACCORD_PERMISSIONS = {
  read: 'accord.read',
  manage: 'accord.manage',
} as const;

export const DEFAULT_ADMIN_PERMISSIONS = ['*'];

/**
 * Fallback permissions when an org has no `member` role doc yet. Mirrors the
 * platform's default member set (see admin-console role.model.ts) plus
 * accord's own read permission so a plain member can use the product.
 */
export const DEFAULT_MEMBER_PERMISSIONS = [
  'workflows.write', 'workflows.delete',
  'members.read', 'billing.read', 'api-keys.read', 'settings.read', 'analytics.read', 'permissions.read',
  'products.read', 'models.read', 'integrations.read',
  'tools.google-maps', 'tools.google-search', 'tools.web-search', 'tools.perplexity', 'tools.firecrawl', 'tools.browserbase',
  ACCORD_PERMISSIONS.read,
];
